import { useState, useRef, useEffect } from 'react';
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuToggle,
  IonIcon,
  useIonRouter,
} from '@ionic/react';
import { logOutOutline, personOutline } from 'ionicons/icons';
import { useAuthStore } from '../../store/useAuthStore';
import { useProfileStore } from '../../store/useProfileStore';
import { logout } from '../../services/authService';
import { Breadcrumb } from '../shared/Breadcrumb';
import { ChangePasswordModal } from './ChangePasswordModal';
import revLogo from '../../assets/REV_logo.svg';
import hamIcon from '../../assets/ham-icon.svg';

export function MobileHeader() {
  const router = useIonRouter();
  const { isAuthenticated } = useAuthStore();
  const { activeProfile } = useProfileStore();
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!userMenuOpen) return;
    function handleClick(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) setUserMenuOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [userMenuOpen]);

  const handleLogout = async () => {
    await logout();
    router.push('/sign-in', 'none');
  };

  return (
    <>
      <IonHeader>
        <IonToolbar className='bg-white'>
          <div slot="start" className="flex items-center">
            <div className="flex items-center px-4 py-4">
              <img src={revLogo} alt="REV Logo" className="h-6 w-auto" />
            </div>
            {isAuthenticated && (
              <IonButtons>
                <IonMenuToggle>
                  <IonButton>
                    <IonIcon icon={hamIcon} className="text-l" color="medium" />
                  </IonButton>
                </IonMenuToggle>
              </IonButtons>
            )}
            <div className="ml-2">
              <Breadcrumb />
            </div>
          </div>

          <IonButtons slot="end">
            {!isAuthenticated ? (
              <IonButton onClick={() => router.push('/sign-in', 'none')}>
                Sign In
              </IonButton>
            ) : (
              <>
                <div ref={menuRef} className="relative">
                  <IonButton onClick={() => setUserMenuOpen(!userMenuOpen)}>
                    <IonIcon icon={personOutline} slot="icon-only" />
                  </IonButton>
                  {userMenuOpen && (
                    <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 py-1 min-w-[160px]">
                      <button
                        onClick={() => { setUserMenuOpen(false); setShowChangePassword(true); }}
                        className="w-full text-left px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
                      >
                        Change Password
                      </button>
                    </div>
                  )}
                </div>
                <IonButton onClick={handleLogout}>
                  <IonIcon icon={logOutOutline} slot="icon-only" />
                </IonButton>
              </>
            )}
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      {showChangePassword && activeProfile && (
        <ChangePasswordModal
          email={activeProfile.email}
          onClose={() => setShowChangePassword(false)}
        />
      )}
    </>
  );
}
